<template>
  <div class="kye-upload-list" :class="className">
    <template v-if="isPopover && innnerFileList.length > 0">
      <el-popover popper-class="kye-upload-popover" placement="bottom" width="204" trigger="hover">
        <kye-preview-list
          :list="innnerFileList"
          v-bind="$attrs"
          @remove="remove">
        </kye-preview-list>
        <kye-button class="popover-success" slot="reference">
          <img src="../images/success.png" alt="" />
          <span>已上传 ({{ innnerFileList.length }})</span>
        </kye-button>
      </el-popover>
    </template>

    <template v-else>
      <template v-if="isPrepend">
        <kye-preview-list
          :list="innnerFileList"
          v-bind="$attrs"
          @remove="remove">
          <template slot="append">
            <upload-load
              v-show="uploadList.length > 0 && isCard"
              v-for="v in uploadList"
              :key="v.id"
              :areaSize="$attrs.itemSize">
            </upload-load>
            <slot name="upload"></slot>
          </template>
        </kye-preview-list>
      </template>

      <template v-else-if="isFooter">
        <slot name="upload" />
        <kye-preview-list
          :list="innnerFileList"
          v-bind="$attrs"
          @remove="remove">
        </kye-preview-list>
      </template>

      <template v-else>
        <upload-load
          v-show="uploadList.length > 0 && isCard"
          v-for="v in uploadList"
          :key="v.id"
          :areaSize="$attrs.itemSize">
        </upload-load>
        <slot name="upload" />
      </template>
    </template>
  </div>
</template>

<script>
  import UploadLoad from './upload-load.vue'
  export default {
    components: {
      UploadLoad
    },

    props: {
      placement: String, // append后置、prepend前置
      visible: {
        type: Boolean,
        default: true
      },
      fileList: Array,
      uploadList: Array,
      mode: {
        type: String,
        default: 'button'
      },
    },

    data () {
      return {
        // uploadList: [
        //   { id: '1' },
        //   { id: '2' },
        // ]
      }
    },

    computed: {
      innnerFileList () {
        return this.fileList.map(v => ({ ...v, url: v.url || v.visit || '' }))
      },
      hasFiles () {
        return this.innnerFileList && this.innnerFileList.length > 0
      },

      isPrepend () {
        return this.placement === 'prepend' && this.hasFiles && this.visible
      },

      isFooter () {
        return this.placement === 'footer' && this.hasFiles && this.visible
      },

      isCard () {
        return this.mode === 'card'
      },

      isPopover () {
        return this.mode === 'popover'
      },

      className () {
        return {
          'is-default': !this.isPrepend && !this.isFooter && this.isCard,
          'is-popover': this.isPopover,
        }
      }
    },

    methods: {
      remove (item) {
        this.$emit('remove', item)
      }
    }
  }
</script>

<style lang="scss">
.kye-upload-list {
  &.is-default {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  &.is-popover {
    .popover-success {
      img {
        width: 12px;
        height: 12px;
        margin-right: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-upload/components/upload-list.vue